import { colors } from '../tokens';

/** Default slider appearance — mirrors exported customSlider for Questionaire. */
const MuiSlider = {
  styleOverrides: {
    root: {
      color: colors.secondary.main,
      height: 8,
    },
    rail: {
      backgroundColor: colors.neutral.sliderRail,
      opacity: 1,
    },
    track: {
      backgroundColor: colors.secondary.main,
      border: 'none',
    },
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: colors.secondary.main,
      border: `2px solid ${colors.secondary.main}`,
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&::before': {
        display: 'none',
      },
    },
    valueLabel: {
      lineHeight: 1.2,
      fontSize: 12,
      background: 'unset',
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: colors.secondary.main,
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&::before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },
      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
  },
};

export default MuiSlider;
